import src from './source';

/**
 * 字段加密、脱敏展示标示
 * 默认为0
 * 1: 加密字段，非参与人查看***格式
 * 2: 脱敏字段，只读情况，****带小眼睛
 * 3: 脱敏格式，打印查看 以及 非参与人监控查看即加密又脱敏字段情况，仅显示***不带小眼睛
 */
export const calculateEncryptFlag = (fieldAttr) =>{
    const htmltype = fieldAttr.htmltype;
    if(htmltype !== 1 && htmltype !== 2)
        return 0;
    const { commonParam, urlParams } = src.globalStore;
    const { isSelfAuth, isprint, iscreate } = commonParam;
    const { isPreView } = urlParams;
    const isPart = isSelfAuth === 1 || iscreate == "1" || isPreView == "1"; //参与权限
    const isviewonly = parseInt(commonParam.isviewonly);
    const { encryptattr={} } = fieldAttr;
    const { desensitization, isEncrypt } = encryptattr;
    //加密字段，非参与人查看密文显示***
    if(isEncrypt === "1" && !isPart)
        return 1;
    //脱敏字段
    if(desensitization === "1"){
        //打印脱敏不显示小眼睛
        if(isprint == "1")
            return 3;
        //只读情况，脱敏格式显示***带小眼睛
        if(isviewonly === 1 || (isviewonly === 0 && fieldAttr.viewattr <= 1))
            return 2;
    }
    return 0;
}

export const judgeDecryptFormat = (value="") =>{
    return (value.startsWith("desensitization__") && value.length == 59)
                    || (value.startsWith("encryption__") && value.length == 54);
}

/**
 * 表单加载数据前，加密分享拦截器
 */
export const verifyEncryptShare = (queryParams, callback) => {
    if (queryParams.isfromchatshare == "1" && !!queryParams.serialid) {
        const { resourcetype, resourceid, sharer, serialid } = queryParams;
        const params = {
            mouldCode: 'WORKFLOW',	// 模块名
            itemCode: 'SHAREBASE',	// 功能项
            targetid: resourceid, 	// 加密对象，如流程或文档id
            serialid: serialid,
            sharer: sharer,   //分享人
            resourcetype: resourcetype,   //分享资源所属模块类型
            encrypt: '0',
        };
        const execFn = src.isMobile ? window.setShare4em : window.setShare4ec;
        if (typeof execFn !== "function") {
            alert('分享打开识别解密方法出现异常，请联系管理员');
            return;
        }
        const verifyFn = () =>{
            execFn(params, data => {
                data.status == '1' && callback();
            });
        }
        if (src.isMobile) {
            verifyFn();
        } else {
            src.globalStore.pushJSCompleteEvent(verifyFn);
        }
    } else
        callback();
}

/**
 * 表单加载前，二次身份认证拦截
 */
export const verifySecondAuth = (queryParams={}, beforeFn, afterFn) =>{
    const urlParams = {...queryParams};
    const isCreate = urlParams.iscreate == "1";
    beforeFn();
    src.API_REQ.loadBaseInfo(urlParams).then(data1 => {
        delete urlParams["preloadkey"];
        if(!isCreate && data1.needSecondAuth === true){
            src.globalStore.setLoading(false);
            //打开表单需要二次身份验证
            const verifyFn = src.isMobile ? window.doCheckSecondaryVerify4em : window.doCheckSecondaryVerify4ec;
            const { requestid, workflowid, nodeid } = data1.params;
            const verifyParams = {
                mouldCode: 'WORKFLOW',	// 模块名
                itemCode: 'NODE',	// 功能项
                requestid, workflowid, nodeid,
            };
            const execFn = () =>{
				if(window.console)
						console.log("verifyParams --1",verifyParams);
                verifyFn(verifyParams, (verifydata) =>{
					if(window.console)
						console.log("verifydata--2",verifydata);
                    if(verifydata.status == "1"){
                        urlParams.hasVerifyAuth = 1;
						urlParams.token = verifydata.token || "";
                        window.API_LOAD_BEGIN = new Date().getTime();
                        beforeFn();
						if(window.console)
							console.log("urlParams--3",urlParams);
                        src.API_REQ.loadBaseInfo(urlParams).then(data2 => {
                            afterFn(data2);
                        });
                    }
                });
            }
            if (src.isMobile) {
                execFn();
            } else {
                src.globalStore.pushJSCompleteEvent(execFn);
            }
        }else{
            afterFn(data1);
        }
    });
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/util/public/encryptUtil.js